module.exports = __webpack_public_path__ + "img/sidemob.48579324.png";